import { render } from "./ReqAgentCertENIncome2YearsView.vue?vue&type=template&id=6ea85531"
import script from "./ReqAgentCertENIncome2YearsView.vue?vue&type=script&lang=js"
export * from "./ReqAgentCertENIncome2YearsView.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__